import React from 'react'

const DummyRows = ({numRows, getHeaderGroups}) => {
  const rows = []
  for (let i = 0; i < numRows; i++) {
    rows.push(
      <tr key={'dummy_' + i} className={'-padRow'}>
        {
          getHeaderGroups().map(headerGroup => (
            headerGroup.headers
              .filter(header => header.column.columnDef.showable !== false)
              .map(header => {
                return (
                  <td
                    key={header.id}
                  >
                  </td>
                )
              })
          ))
        }
      </tr>
    )
  }
  return rows
}

export default DummyRows